import api from "../../utils/axios";
import { BULK_ORDER_OPERATIONS_ENDPOINTS } from "./endpoints";
import { BulkOrderOperationResponse, SetSectionIdRequest } from "./types";

export const setOrdersSectionId = async (
	body: SetSectionIdRequest
): Promise<BulkOrderOperationResponse> => {
	const response = await api.post<BulkOrderOperationResponse>(
		BULK_ORDER_OPERATIONS_ENDPOINTS.setSectionId,
		body
	);
	return response.data;
};
